import { Application, BasePlugin, I18n, i18n } from '@goodboydigital/astro';

import { App } from '../App';
import { Settings } from '../AppConfig';

export class LanguagePlugin implements BasePlugin
{
    public app: App;

    constructor(app: Application)
    {
        this.app = app as App;
    }

    public start():void
    {
        // Setup a default font
        I18n.defaultEntry.fontName = 'lubalin';

        // Fetch localisation data resource
        const localisation = this.app.assets.getData('localisation') as any;

        // Append dictionaries for all languages listed
        for (const id in localisation) i18n.appendDictionary(id, localisation[id]);
        
        var defaultLanguage = Settings.language || (Settings.isApp() ? undefined : "en_GB");
        try
        {
            i18n.changeLanguage(this.app.settings.language || Settings.language);
            this.app.settings.language = i18n.language;
            console.log(`[LanguagePlugin] Language changed to: ${i18n.language}`);
        }
        catch (e)
        {
            console.warn(`[LanguagePlugin] Language not avaliable: ${this.app.settings.language}`);
            if(defaultLanguage){
                i18n.changeLanguage(defaultLanguage);
                this.app.settings.language = defaultLanguage;
            }
            
        }
    }

    public changeLanguage(code: string): void
    {
        // Set current language
        i18n.language = code;
    }
}
